export const formInitialValues = (data = {}) => ({
    group_coa_id: data?.group_coa_id ?? "",
    account_type_code: data?.account_type_code ?? "",
    account_type_name: data?.account_type_name ?? "",
    description: data?.description ?? "",
  });
  